export const FIRM = {
  name: "Helkar & Associates",
  advocate: "Adv. Prasad Helkar",
  tagline: "Committed to Justice. Dedicated to Excellence.",
  altTagline: "Trusted Legal Counsel. Practical Solutions. Strong Representation.",
  phone: "+91 9920349263",
  phoneRaw: "+919920349263",
  email: "helkarandassociates@gmail.com",
  whatsapp: "https://wa.me/919920349263",
  address: {
    line1: "2B/07, Phoenix Paragon Plaza",
    line2: "LBS Marg, Kurla West",
    city: "Mumbai",
    pin: "400 070",
    country: "India",
  },
  hours: "Mon – Sat · 10:00 – 19:00 IST",
  founded: "MUMBAI · 2017",
};

export const CLIENTS = [
  {
    name: "Dashmile Lubtech Pvt. Ltd.",
    url: "https://dashmile.in/",
    logo: "https://dashmile.in/wp-content/uploads/2024/03/Quality_Products_for_Ever-1-removebg-preview.png",
  },
  {
    name: "Zentrex",
    url: "https://zentrex.in/",
    logo: "https://zentrex.in/assets/images/logo/zentrex%20logo.svg",
  },
  {
    name: "Sachin Packaging",
    url: "",
    logo: "",
  },
  {
    name: "S2M Chemicals",
    url: "http://s2mchemicals.com/",
    logo: "",
  },
  {
    name: "BSM Digitech Pvt. Ltd.",
    url: "",
    logo: "",
  },
  {
    name: "Dentistree Dental Clinic",
    url: "",
    logo: "",
  },
  {
    name: "Mass Instrument India LLP",
    url: "",
    logo: "",
  },
  {
    name: "Alkemi Decor Designs Pvt. Ltd.",
    url: "",
    logo: "",
  },
];


export const TEAM = [
  { name: "Adv. Prasad Helkar", role: "Founder & Managing Advocate", initials: "PH" },
  { name: "Adv. Sushma Patil", role: "Co-Founder & Advocate", initials: "SP" },
  { name: "Adv. Pooja Kesarkar", role: "Associate Advocate", initials: "PK" },
  { name: "Adv. Gauri Devarkar", role: "Associate Advocate", initials: "GD" },
  { name: "Adv. Manoj Chaurasiya", role: "Associate Advocate", initials: "MC" },
  { name: "Aditri Bhatt", role: "Intern", initials: "AB" },
  { name: "Amisha Sinha", role: "Intern", initials: "AS" },
  { name: "Abhishek Lature", role: "Intern", initials: "AL" },
];

export const PRACTICE_AREAS = [
  {
    slug: "family-law",
    num: "01",
    title: "Family Law",
    lede: "Divorce, custody, maintenance and matrimonial disputes handled with discretion and dignity.",
    hero: "https://images.unsplash.com/photo-1609220136736-443140cffec6?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Divorce", "Mutual Consent Divorce", "Child Custody", "Domestic Violence",
      "Maintenance", "Restitution of Conjugal Rights", "Guardianship",
      "Adoption", "Marriage Registration", "Family Court Litigation",
    ],
    who: "Individuals navigating divorce, custody or matrimonial disputes; NRIs seeking counsel across jurisdictions.",
    approach: "We prioritise mediation where possible and litigate firmly where necessary — always safeguarding client confidentiality and the interests of children.",
    process: [
      "Confidential consultation & case assessment",
      "Documentation & legal strategy",
      "Mediation, notice or petition drafting",
      "Court representation across Family & High Court",
      "Post-decree enforcement & compliance",
    ],
  },
  {
    slug: "criminal-law",
    num: "02",
    title: "Criminal Law",
    lede: "Urgent bail, quashing, trials and appeals — Sessions to High Court, 24×7 assistance available.",
    hero: "https://images.unsplash.com/photo-1589994965851-a8f479c573a9?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Anticipatory Bail", "Regular Bail", "Quashing of FIR", "Criminal Trials",
      "White Collar Crimes", "Cheque Bounce (S.138 NI Act)", "Cyber Crime",
      "Economic Offences", "Criminal Appeals", "Sessions & High Court Matters",
    ],
    who: "Accused persons, complainants, corporates facing investigation, and those needing urgent bail assistance.",
    approach: "Rapid response, meticulous procedural safeguards and courtroom advocacy grounded in evidence and precedent.",
    process: [
      "Immediate case review (24×7 bail line)",
      "Anticipatory / regular bail application",
      "Trial defence & witness examination",
      "Appeals before Sessions & High Court",
      "Compliance, revision and remedy tracking",
    ],
    highlight: true,
  },
  {
    slug: "corporate-law",
    num: "03",
    title: "Corporate & Commercial",
    lede: "Incorporation, contracts, compliance, M&A and legal audits for founders and companies.",
    hero: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Company Incorporation", "Legal Advisory", "Corporate Compliance",
      "Commercial Agreements", "Shareholder Agreements", "Employment Contracts",
      "Due Diligence", "Mergers & Acquisitions", "Business Structuring",
      "Legal Opinions", "Contract Drafting",
    ],
    who: "Founders, growing businesses, financial institutions and multinationals doing business in India.",
    approach: "Pragmatic counsel tuned to commercial reality — we protect the deal without slowing it down.",
    process: [
      "Discovery & structuring workshop",
      "Contract & compliance audit",
      "Drafting, negotiation & closing",
      "Ongoing retainer advisory",
      "Dispute mitigation & recovery",
    ],
  },
  {
    slug: "civil-litigation",
    num: "04",
    title: "Civil Litigation",
    lede: "Property, recovery, injunctions and specific performance — trial-tested representation.",
    hero: "https://images.unsplash.com/photo-1505664194779-8beaceb93744?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Recovery Suits", "Property Disputes", "Injunctions", "Partition Suits",
      "Specific Performance", "Declaration Suits", "Consumer Matters",
      "Contractual Disputes", "Commercial Suits",
    ],
    who: "Owners in property disputes, businesses seeking recovery, and parties requiring injunctive relief.",
    approach: "Strategic litigation with clear cost forecasting, milestone reviews and settlement discipline.",
    process: [
      "Cause of action mapping",
      "Interim relief & pleadings",
      "Trial preparation & evidence",
      "Argument & final judgment",
      "Execution & enforcement",
    ],
  },
  {
    slug: "testamentary-succession",
    num: "05",
    title: "Testamentary & Succession",
    lede: "Wills, probate, letters of administration, succession certificates and estate planning.",
    hero: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Probate", "Letters of Administration", "Succession Certificate",
      "Will Drafting", "Estate Planning", "Will Disputes", "Inheritance Matters",
    ],
    who: "Families safeguarding legacy, executors administering estates, and heirs contesting or defending a will.",
    approach: "Careful documentation, tax-aware structuring and empathetic handling of family sensitivities.",
    process: [
      "Estate mapping & risk review",
      "Will / trust drafting",
      "Probate or LOA petition",
      "Objections & evidence, if any",
      "Distribution & closure",
    ],
  },
  {
    slug: "drt-sarfaesi",
    num: "06",
    title: "Debt Recovery Tribunal",
    lede: "Bank recovery, SARFAESI proceedings and appeals before DRT and DRAT.",
    hero: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Bank Recovery Proceedings", "SARFAESI Matters", "Recovery of Debts",
      "Appeals before DRAT", "Financial Institution Litigation",
      "Loan Recovery", "Enforcement Proceedings",
    ],
    who: "Banks, NBFCs, ARCs, borrowers and guarantors involved in secured lending disputes.",
    approach: "Deep familiarity with DRT practice and financial documentation gives our clients a procedural edge.",
    process: [
      "Documentation & jurisdictional review",
      "Recovery / securitisation application",
      "Interlocutory reliefs & possession",
      "DRT arguments & final order",
      "DRAT appeal & execution",
    ],
  },
  {
    slug: "mact",
    num: "07",
    title: "Motor Accident Claims",
    lede: "Compensation for injury, disability and fatal accidents — including insurance disputes.",
    hero: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Compensation Claims", "Fatal Accident Claims", "Injury Compensation",
      "Insurance Claim Disputes", "Tribunal Representation", "Appeals",
    ],
    who: "Accident victims, families of deceased, and insurers contesting quantum or liability.",
    approach: "Evidence-led quantification of loss, medical documentation and precedent-driven arguments before MACT.",
    process: [
      "Case intake & evidence collection",
      "Petition & interim compensation",
      "Medical assessment & quantum",
      "Tribunal representation",
      "Appeal & execution, if needed",
    ],
  },
  {
    slug: "cooperative-housing-society",
    num: "08",
    title: "Cooperative Housing Society",
    lede: "Society formation, conveyance, redevelopment and member disputes under the Maharashtra Co-operative Societies Act.",
    hero: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Society Registration", "Conveyance & Deemed Conveyance", "Redevelopment Agreements",
      "Member & Committee Disputes", "Bye-law Compliance & Amendment", "Recovery of Maintenance Dues",
      "Managing Committee Elections", "Co-operative Court Litigation", "Transfer of Flats & Shares",
      "Society Meetings & Notices",
    ],
    who: "Housing societies, managing committees, individual members and developers involved in formation, conveyance or redevelopment.",
    approach: "We combine deep familiarity with the MCS Act and bye-laws with a practical, harmony-first approach — resolving disputes without paralysing the society's functioning.",
    process: [
      "Records & bye-law review",
      "Notice, resolution or petition drafting",
      "Deemed conveyance / redevelopment steps",
      "Representation before Registrar & Co-op Court",
      "Compliance, appeals & enforcement",
    ],
  },
  {
    slug: "redevelopment",
    num: "09",
    title: "Redevelopment",
    lede: "End-to-end advisory on society and building redevelopment — from developer selection to conveyance.",
    hero: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Development Agreements", "Developer Selection & Tendering", "Feasibility & Legal Due Diligence",
      "PAAA (Permanent Alternate Accommodation Agreements)", "Members' Consent & Resolutions",
      "MOFA / RERA Compliance", "Dispute Resolution", "Handover & Conveyance",
    ],
    who: "Housing societies, members and developers undertaking redevelopment of ageing buildings in Mumbai.",
    approach: "We protect members' interests through watertight agreements, transparent tendering and RERA-compliant documentation.",
    process: [
      "Feasibility & title due diligence",
      "Developer tender & selection",
      "Development & PAAA agreements",
      "Approvals, RERA & construction phase",
      "Possession, OC & conveyance",
    ],
  },
  {
    slug: "conveyance-property-transfer",
    num: "10",
    title: "Conveyance & Property Transfer",
    lede: "Conveyance, deemed conveyance and clean transfer of title for flats, plots and commercial premises.",
    hero: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Conveyance Deeds", "Deemed Conveyance", "Sale & Transfer Deeds", "Gift & Release Deeds",
      "Title Search & Verification", "Stamp Duty & Registration", "Property Mutation", "Encumbrance Clearance",
    ],
    who: "Buyers, sellers, societies and heirs seeking clear, marketable title and lawful transfer of property.",
    approach: "Meticulous title investigation and drafting so ownership passes cleanly, with no lingering encumbrances.",
    process: [
      "Title search & document review",
      "Deed drafting & vetting",
      "Stamp duty assessment",
      "Registration & mutation",
      "Post-transfer compliance",
    ],
  },
  {
    slug: "rent-control",
    num: "11",
    title: "Rent Control Law",
    lede: "Landlord–tenant disputes, eviction, standard rent and possession under the Maharashtra Rent Control Act.",
    hero: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Eviction Proceedings", "Standard Rent Fixation", "Arrears of Rent Recovery", "Possession Suits",
      "Leave & Licence Disputes", "Tenancy Rights", "Repairs & Reconstruction Matters",
    ],
    who: "Landlords and tenants navigating eviction, rent revision, possession or tenancy protection.",
    approach: "Balanced, statute-driven strategy that pursues possession or protection efficiently before the Small Causes Court.",
    process: [
      "Tenancy documentation review",
      "Statutory notice",
      "Suit / application filing",
      "Trial & evidence",
      "Decree & execution",
    ],
  },
  {
    slug: "labour-employment",
    num: "12",
    title: "Labour & Employment",
    lede: "Employment contracts, industrial disputes, terminations and compliance for employers and employees.",
    hero: "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Employment Agreements", "Wrongful Termination", "Industrial Disputes", "Labour Court & Tribunal Matters",
      "POSH Compliance", "Gratuity & PF Disputes", "Disciplinary Proceedings", "HR Policy & Compliance",
    ],
    who: "Employers, HR teams, employees and workmen involved in employment disputes or compliance.",
    approach: "Commercially aware counsel that manages risk for employers while protecting the legitimate rights of employees.",
    process: [
      "Contract & policy audit",
      "Notice / conciliation",
      "Representation before Labour Court",
      "Award & compliance",
      "Appeals, if required",
    ],
  },
  {
    slug: "arbitration",
    num: "13",
    title: "Arbitration & Mediation",
    lede: "Commercial arbitration, mediation and enforcement of awards under the Arbitration & Conciliation Act.",
    hero: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Domestic & Commercial Arbitration", "Drafting Arbitration Clauses", "Appointment of Arbitrators",
      "Interim Relief (S.9)", "Challenge to Awards (S.34)", "Enforcement of Awards", "Mediation & Conciliation",
    ],
    who: "Businesses and individuals seeking faster, confidential resolution of commercial disputes outside court.",
    approach: "Efficient, confidential dispute resolution with strong drafting up front and firm advocacy in the hearing room.",
    process: [
      "Clause / notice invocation",
      "Constitution of tribunal",
      "Pleadings & interim relief",
      "Hearings & award",
      "Enforcement or challenge",
    ],
  },
  {
    slug: "intellectual-property",
    num: "14",
    title: "Intellectual Property (IPR)",
    lede: "Trademark, copyright and design protection, registration and infringement litigation.",
    hero: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Trademark Registration", "Copyright Registration", "Design Registration", "IP Infringement Suits",
      "Passing-off Actions", "Licensing & Assignment", "Cease & Desist Notices", "IP Due Diligence",
    ],
    who: "Founders, brands, creators and enterprises protecting and enforcing their intellectual property.",
    approach: "Protect first, enforce decisively — we secure registrations early and litigate infringement firmly.",
    process: [
      "IP audit & search",
      "Filing & prosecution",
      "Registration & records",
      "Infringement action",
      "Licensing & monetisation",
    ],
  },
  {
    slug: "it-cyber-law",
    num: "15",
    title: "Information Technology & Cyber Law",
    lede: "Cyber-crime defence, data protection, IT Act compliance and online dispute resolution.",
    hero: "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Cyber-crime Complaints & Defence", "Data Protection & Privacy", "IT Act Compliance",
      "Online Defamation", "E-commerce & Technology Contracts", "Digital Fraud Recovery", "Social Media Disputes",
    ],
    who: "Individuals and companies facing cyber-crime, data breaches, online defamation or IT compliance needs.",
    approach: "Rapid, evidence-preserving response to digital wrongs, combined with proactive compliance advisory.",
    process: [
      "Incident assessment & evidence",
      "Complaint with Cyber Cell",
      "Compliance / takedown notices",
      "Litigation or defence",
      "Remediation & policy",
    ],
  },
  {
    slug: "consumer-protection",
    num: "16",
    title: "Consumer Protection",
    lede: "Consumer complaints, deficiency of service and unfair trade practices before Consumer Commissions.",
    hero: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Consumer Complaints", "Deficiency of Service", "Unfair Trade Practices", "Product Liability",
      "Real Estate & Builder Complaints", "Insurance & Banking Complaints", "District / State / National Commission",
    ],
    who: "Consumers seeking redress and businesses defending complaints before Consumer Commissions.",
    approach: "Focused, document-led advocacy to secure refunds, compensation and relief efficiently.",
    process: [
      "Grievance & notice",
      "Complaint drafting & filing",
      "Evidence & affidavits",
      "Hearing & order",
      "Execution or appeal",
    ],
  },
  {
    slug: "document-registration",
    num: "17",
    title: "Registration of Documents",
    lede: "Drafting, stamping and registration of deeds, agreements and important legal documents.",
    hero: "https://images.unsplash.com/photo-1423592707957-3b212afa6733?q=80&w=1600&auto=format&fit=crop",
    services: [
      "Agreement Drafting", "Sale & Lease Deeds", "Power of Attorney", "Affidavits & Declarations",
      "Stamp Duty Advisory", "Sub-Registrar Registration", "Notarisation", "Document Vetting",
    ],
    who: "Individuals and businesses needing correctly drafted, stamped and registered legal documents.",
    approach: "Precise drafting and correct stamping so your documents are legally sound and readily enforceable.",
    process: [
      "Requirement & drafting",
      "Stamp duty computation",
      "Execution & witnessing",
      "Sub-Registrar registration",
      "Certified copies & records",
    ],
  },
];

export const FAQS = [
  { q: "How do I book a consultation with Helkar & Associates?", a: "You may call +91 9920349263, message on WhatsApp, or submit the consultation form on this site. We will confirm your slot within one working day." },
  { q: "Do you handle urgent bail matters?", a: "Yes. Our criminal team offers 24×7 assistance for anticipatory and regular bail before the Magistrate, Sessions Court and High Court." },
  { q: "Where is your office located?", a: "2B/07, Phoenix Paragon Plaza, LBS Marg, Kurla West, Mumbai – 400 070. Client meetings are by appointment." },
  { q: "Do you appear only in Mumbai?", a: "We are based in Mumbai but represent clients across India through appearances, briefs and coordinated counsel networks." },
  { q: "What fees do you charge?", a: "Fees depend on complexity, forum and time commitment. We provide a written engagement letter with a clear fee estimate before you retain us." },
  { q: "Can NRIs engage the firm remotely?", a: "Yes. We regularly represent NRIs and handle matrimonial, property and inheritance matters with power-of-attorney based representation." },
  { q: "How long does a divorce take in India?", a: "A mutual-consent divorce may conclude in six to twelve months. Contested divorces vary based on evidence and court calendar." },
  { q: "What is anticipatory bail?", a: "It is a pre-arrest bail granted by the Sessions Court or High Court under Section 482 BNSS (formerly S.438 CrPC) when there is apprehension of arrest in a cognisable offence." },
  { q: "How is a cheque bounce case pursued?", a: "A statutory notice under Section 138 of the NI Act is issued within 30 days of dishonour, followed by a complaint before the Magistrate if payment is not made." },
  { q: "Can you draft a will for me?", a: "Yes. We draft wills tailored to family circumstances, including provisions for guardianship, executors and asset distribution across jurisdictions." },
  { q: "What is a succession certificate?", a: "A succession certificate is granted by a civil court to a deceased's legal heirs, enabling them to collect debts and securities." },
  { q: "What does SARFAESI mean for a borrower?", a: "It empowers secured lenders to take possession of collateral and sell it to recover dues, subject to notice under Sections 13(2) and 13(4). Borrowers may challenge action under Section 17 before the DRT." },
  { q: "What compensation can be claimed under MACT?", a: "Compensation includes medical expenses, loss of income, disability, pain and suffering; in fatal cases it includes loss of dependency and consortium." },
  { q: "Do you offer retainer arrangements for companies?", a: "Yes. We offer monthly and annual retainers covering advisory, contracts, compliance and dispute early-warning support." },
  { q: "Is my consultation confidential?", a: "Absolutely. Attorney–client privilege applies from the first exchange and we maintain strict information security protocols." },
  { q: "Do you take pro bono matters?", a: "Selectively, yes. We evaluate requests on merit, urgency and social impact." },
  { q: "Can I upload case documents online?", a: "Yes, through our contact form. Sensitive documents can be shared over secure email after we confirm engagement." },
  { q: "Do you provide legal opinions?", a: "Yes — reasoned written opinions on complex questions of law and commercial risk are one of our core offerings." },
  { q: "How do you charge for court appearances?", a: "Appearance fees vary by forum (Magistrate, Sessions, High Court) and are set out in the engagement letter." },
  { q: "Do you handle cyber-crime FIRs?", a: "Yes — from filing complaints with the Cyber Cell to defending accused persons and prosecuting IP/data breach matters." },
];

export const BLOGS = [
  {
    slug: "anticipatory-bail-mumbai",
    title: "Anticipatory Bail in Maharashtra: A Practical Guide",
    category: "Criminal Law",
    date: "2025-09-14",
    reading: "6 min",
    hero: "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1600&auto=format&fit=crop",
    excerpt: "When the apprehension of arrest looms, anticipatory bail is often the difference between due process and detention. Here is how the remedy actually works in Mumbai courts.",
    body: [
      "Under Section 482 of the Bharatiya Nagarik Suraksha Sanhita, a person apprehending arrest in a cognisable offence may approach the Sessions Court or High Court for a direction that in the event of arrest, they be released on bail.",
      "The court weighs the nature and gravity of the accusation, the antecedents of the applicant, the possibility of the applicant fleeing from justice, and whether the accusation appears to have been made with the object of injuring or humiliating the applicant by having them arrested.",
      "In Mumbai practice, applications are typically first moved before the Sessions Court, with the High Court reserved for matters of greater complexity or when relief is denied below. Interim protection may be granted pending final orders.",
      "Documentation matters: a well-prepared petition places the FIR, station diary entries, and the applicant's antecedents before the court along with any mitigating material such as employment, family responsibilities, or medical grounds.",
    ],
  },
  {
    slug: "mutual-consent-divorce",
    title: "Mutual Consent Divorce: The Six-Month Cooling Period Explained",
    category: "Family Law",
    date: "2025-10-02",
    reading: "5 min",
    hero: "https://images.unsplash.com/photo-1655720406101-b4be4fe1fe12?q=80&w=1600&auto=format&fit=crop",
    excerpt: "Section 13B of the Hindu Marriage Act sets out a two-stage process. The Supreme Court has clarified when the six-month cooling-off can be waived — and when it cannot.",
    body: [
      "A mutual consent divorce requires the parties to have lived separately for a period of one year and to file a joint petition attesting that they are unable to live together and have agreed to dissolve the marriage.",
      "The statute contemplates a second motion after six months from the first, giving the parties time to reconsider. The Supreme Court in Amardeep Singh v Harveen Kaur held that this period is directory and may be waived where reconciliation is not possible and the parties have settled all issues.",
      "Practical drafting matters: a robust settlement covering maintenance, streedhan, custody and future correspondence prevents post-decree litigation. We recommend a joint memorandum recorded before the court on the day of the second motion.",
    ],
  },
  {
    slug: "sarfaesi-basics",
    title: "SARFAESI 101: What Every Borrower Should Know",
    category: "DRT & SARFAESI",
    date: "2025-11-11",
    reading: "7 min",
    hero: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?q=80&w=1600&auto=format&fit=crop",
    excerpt: "The SARFAESI Act gives banks a fast-track to recovery of secured debt. Borrowers have limited but meaningful remedies — provided they act in time.",
    body: [
      "SARFAESI applies to secured creditors with an outstanding of over one lakh rupees, where the borrower has been classified as a non-performing asset in accordance with RBI directions.",
      "A Section 13(2) notice provides sixty days to pay. If the borrower fails to comply, the secured creditor may take symbolic possession under Section 13(4). Actual possession, and sale, follow due process including notice of thirty days before sale.",
      "The borrower's principal remedy is an application under Section 17 before the DRT within forty-five days of the measure complained of. Appeal lies to the DRAT under Section 18 subject to statutory deposit.",
    ],
  },
  {
    slug: "will-drafting-mistakes",
    title: "Five Mistakes to Avoid When Drafting Your Will",
    category: "Testamentary",
    date: "2025-11-28",
    reading: "4 min",
    hero: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=1600&auto=format&fit=crop",
    excerpt: "A poorly drafted will can undo a lifetime of careful planning. Here are the recurring drafting errors we see in probate disputes.",
    body: [
      "Ambiguous language over jointly-held or nominated assets frequently invites litigation. A will should clearly identify assets, exclude those held in survivorship, and address nominations that operate as trustees rather than beneficial owners.",
      "Witnesses matter. Two witnesses must attest the signature — beneficiaries and their spouses should be avoided as attesting witnesses to prevent challenges to the bequest.",
      "Executor appointment is often overlooked. A named executor smooths probate and ensures continuity of administration.",
    ],
  },
];
